var exports = {
  "kL": "ChannelInvitesTab.module__container___QjNONU",
  "wx": "ChannelInvitesTab.module__header___QjNONU",
  "h_": "ChannelInvitesTab.module__description___QjNONU",
  "GC": "ChannelInvitesTab.module__buttonGroup___QjNONU",
  "dc": "ChannelInvitesTab.module__spinnerContainer___QjNONU",
  "sJ": "ChannelInvitesTab.module__invitesContainer___QjNONU",
  "$h": "ChannelInvitesTab.module__invitesList___QjNONU",
  "eu": "ChannelInvitesTab.module__inviteItems___QjNONU",
};

module.exports = exports;
